import React from 'react';

const InsurancePolicyDetailsPage = () => {
  return <></>;
};

export { InsurancePolicyDetailsPage };
